const i18n = {

  namespaced: true,
  state: {
    currentLocale: 0,
    selectedLocales: [],
  },

  actions: {
    LOCALES_CHECK({commit}) {
      // Set value with a default;
      let value = [{locale: 'en', distance: '2 meters'}];

      // If item is present in localStorage overwrite;
      if (localStorage.getItem('selectedLocales')) {
        value = JSON.parse(localStorage.getItem('selectedLocales'));
      }

      commit('setLocales',value);
    },

    SET({commit}, locales) {
      return new Promise((resolve) => {
        localStorage.setItem('selectedLocales',JSON.stringify(locales));
        commit('setLocales',locales);
        resolve();
      });
    },
    NEXT({state, commit}, instance) {
      let nextIndex = state.currentLocale + 1;
      if (nextIndex > state.selectedLocales.length - 1) nextIndex = 0;
      commit('nextLocale',nextIndex);
      instance.locale = state.selectedLocales[nextIndex].locale;
    }
  },
  mutations: {
    setLocales(state, locales) {
      state.selectedLocales = locales;
    },
    nextLocale(state, index) {
      state.currentLocale = index;
    }
  },
  getters: {
    current(state) {
      return state.selectedLocales[state.currentLocale];
    },
    selected(state) {
      return state.selectedLocales;
    }
  }
};

export default i18n;